import { AiOutlineCloudServer } from "@onemind-services-llc/react-icons-ng/ai";
import {
  MdOutlineStorage,
  MdCastForEducation,
} from "@onemind-services-llc/react-icons-ng/md";
import { LEARNING_LABS } from "../learningLabsTable/constants";

export const SIDEBAR_OPTIONS = [
  { icon: AiOutlineCloudServer, label: "Cloud Instances", value: "cloud-instances" },
  { icon: AiOutlineCloudServer, label: "Baremetal", value: "baremetal" },
  { icon: AiOutlineCloudServer, label: "Baremetal Cluster", value: "baremetal-cluster" },
  {
    icon: MdCastForEducation,
    label: LEARNING_LABS.dataCenter.label,
    value: LEARNING_LABS.dataCenter.id,
  },
  {
    icon: MdCastForEducation,
    label: LEARNING_LABS.enterprise.label,
    value: LEARNING_LABS.enterprise.id,
  },
  {
    icon: MdCastForEducation,
    label: LEARNING_LABS.security.label,
    value: LEARNING_LABS.security.id,
  },
  {
    icon: MdOutlineStorage,
    label: "Managed Colocation",
    value: "managed-colocation-price",
  },
];
